import { api, getData } from './request';
import type { CustomerOrganisation } from '@cutr/constants/order';
import type {
  CustomerOrganisationListRow,
  CustomerOrganisationProfile,
} from '@cutr/constants/organisations';

export function getCustomerOrganisations(signal?: AbortSignal) {
  return getData<CustomerOrganisationListRow[]>('/v2/customer-organisations', {
    signal,
  });
}

export function getCustomerOrganisationProfile(
  customerOrganisationId: string,
  signal?: AbortSignal
) {
  return getData<CustomerOrganisationProfile>(
    `/v2/customer-organisations/${customerOrganisationId}/profile`,
    { signal }
  );
}

export function getCustomerOrganisation(
  customerOrganisationId: string,
  signal?: AbortSignal
) {
  return getData<CustomerOrganisation>(
    `/v2/customer-organisations/${customerOrganisationId}`,
    { signal }
  );
}

export function deleteCustomerOrganisationMember(
  customerOrganisationId: string,
  memberId: string
) {
  return api
    .delete(
      `/v2/customer-organisations/${customerOrganisationId}/members/${memberId}`
    )
    .then(() => undefined);
}
